import { defineMessages } from "@formatjs/intl"
import type { StockStatusFilter } from "./StockStatusFilter"

export const stockStatusFilterMessages = defineMessages<
	Extract<StockStatusFilter, "INCOMING_PRE_PRODUCTION" | "INCOMING_PRODUCED">
>({
	INCOMING_PRE_PRODUCTION: {
		defaultMessage: "Incoming (V100 to V260)",
		id: "vehicle.stockStatusFilter.incomingV100toV260",
	},
	INCOMING_PRODUCED: {
		defaultMessage: "Incoming (from V300)",
		id: "vehicle.stockStatusFilter.incomingFromV300",
	},
})
